import { keyframes } from "styled-components";

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const slideUp = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const slideInDown = keyframes`
  0% {
    transform: translateY(-1000px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const slideOutUp = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-1000px);
  }
`;

export const slideInDownLarge = keyframes`
  0% {
    transform: translateY(-1600px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const slideOutUpLarge = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-1600px);
  }
`;

export const shine = keyframes`
  0% {
    background-position: 0;
  }
  60% {
    background-position: 500px;
  }
  100% {
    background-position: 1000px;
  }
`;

export const rotate3D = keyframes`
  0% { 
    transform: rotateY(-45deg); 
  }
  100% { 
    transform: rotateY(90deg); 
  }
`;

export const ringSpin = keyframes`
  0% { 
    transform: translate(-50%, -50%) rotate(0deg); 
  }
  100% { 
    transform: translate(-50%, -50%) rotate(360deg); 
  }
`;
